var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_3573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75874 10.1667L0.967077 13.5834C0.939767 13.7083 0.940703 13.8377 0.969817 13.9622C0.998931 14.0867 1.05549 14.2031 1.13535 14.3029C1.21522 14.4028 1.31638 14.4835 1.43144 14.5392C1.5465 14.5949 1.67256 14.6243 1.80041 14.625C1.85998 14.6311 1.92001 14.6311 1.97958 14.625L5.41708 13.8334L12.0171 7.25837L8.33374 3.58337L1.75874 10.1667Z",
    fill: "#415473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0924 3.96661L11.6341 1.50828C11.4725 1.34747 11.2538 1.2572 11.0258 1.2572C10.7978 1.2572 10.5791 1.34747 10.4174 1.50828L9.05078 2.87495L12.7299 6.55411L14.0966 5.18745C14.1766 5.10706 14.2399 5.0117 14.283 4.90681C14.3261 4.80192 14.3481 4.68956 14.3477 4.57617C14.3473 4.46277 14.3246 4.35057 14.2808 4.24597C14.237 4.14138 14.173 4.04645 14.0924 3.96661Z",
    fill: "#415473"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_3573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.803ff7523c722cbc1946528e7824f560.svg";
export { ForwardRef as ReactComponent };